import { useErrorMessage } from "@poseidon/ui/app/toasts/useErrorMessage";
import { useToastMessage } from "@poseidon/ui/app/toasts/useToastMessage";
import { functions } from "@poseidon/firebase/firebase";
import { useCallback, useState } from "react";
import { useHttpsCallable } from "react-firebase-hooks/functions";

export const useCreateOpenBankingConnection = () => {
  const [loading, setLoading] = useState(false);
  const { setError } = useErrorMessage();
  const { setToast } = useToastMessage();
  const [executeCallable, saving, error] = useHttpsCallable(
    functions,
    "connectOpenBanking"
  );

  const run = useCallback(
    async (sailorId: string, testPersonaName?: string) => {
      try {
        setLoading(true);
        await executeCallable({
          sailorId,
          ...(testPersonaName ? { testPersonaName } : {}),
        });
        setToast("Open Banking connection initiated");
      } catch (error) {
        if (error instanceof Error) {
          setError(error.message);
        } else {
          setError("Unknown error");
        }
      }
      setLoading(false);
    },
    [executeCallable, setError, setToast]
  );

  return { run, loading: loading || saving, error };
};
